import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {FormGroup, Row} from 'react-bootstrap';
import InputDate from '../../../components/FormFields/inputDate/InputDate';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {getLanguage, t} from 'react-switch-lang';
import InputText from '../../../components/FormFields/InputText';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers';
import {appModules, validNumberRegex} from '../../../utils/const';
import {Spin} from 'antd';
import SelectList from '../../../components/FormFields/select/SelectList';
import {format, addDays} from 'date-fns';
import {act} from 'react-dom/test-utils';

const RiskFilter = ({submit, activeTab, user, departments}) => {
  const [roleDisabled, setRoleDisabled] = useState(
    user.authorities.includes('ROLE_RISK_SECTOR')
  );
  const [defaultDepartment, setDefaultDepartment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const lang = getLanguage();

  useEffect(() => {
    let arr = [];
    departments.map((item) => {
      arr.push({value: item.id, label: item.name});
    });
    setDepartmentOptions(arr);
  }, [departments]);

  useEffect(() => {
    const arr = [];
    departments.map((item, idx) => {
      arr.push({
        value: item.id,
        label: lang === 'mne' ? item.name : item.nameEn,
      });
    });
    setDefaultDepartment(arr);
    setLoading(false);
  }, [departments]);

  const optionsTask = [
    {value: 'id', label: `${t('risk-cosideration.id')}`},
    {value: 'title', label: `${t('risk-cosideration.title')}`},
    {value: 'estimation', label: `${t('risk-cosideration.estimation')}`},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      id: yup.object().nullable(),
      riskEstimationId: yup.object().nullable(),
      riskEstimationEvaluation: yup.object().nullable(),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
    //shouldUnregister: false
  });

  const {handleSubmit, watch, setValue, reset,errors} = methods;
  const validFrom = watch('dateCreated');
  const validTo = watch('dateUpdated');
  const select = watch('selectRisk');
  const departmentWatch = watch('department');
  const minDateForUpdated = validFrom ? addDays(validFrom, 1) : null;
  const maxDateForCreated = validTo ? addDays(validTo, -1) : null;

  useEffect(() => {
    if (select?.value === 'id' || select?.value === 'estimation') {
      setSchema(
        yup.object().shape({
          searchInput: yup
            .string()
            .trim()
            .matches(validNumberRegex, t('message.onlyNumbers')),
          selectRisk:yup
              .object()
              .nullable()
              .when("searchInput", (searchInput, schema) => {

                if(searchInput.length > 0 && !watch('selectRisk') &&  !errors.searchInput && validNumberRegex.test(searchInput) )
                  return schema.required(t('message.mustChooseSearchOption'))
                return schema
              })


        })
      );
    } else {
      setSchema(
        yup.object().shape({
          searchInput: yup.string().trim(),
          selectRisk:yup
              .object()
              .nullable()
              .when("searchInput", (searchInput, schema) => {

                if(searchInput.length > 0 && !watch('selectRisk'))
                  return schema.required(t('message.mustChooseSearchOption'))
                return schema
              })

        })
      );
    }
  }, [select]);

  useEffect(() => {
    if (
      activeTab === 'occured' &&
      departmentWatch === null &&
      roleDisabled === false
    ) {
      setValue('department', defaultDepartment);
    }
    if (
      activeTab === 'litigation' &&
      departmentWatch === null &&
      roleDisabled === false
    ) {
      setValue('department', defaultDepartment);
    }
  }, [departmentWatch]);

  useEffect(() => {
    let local;
    if (activeTab === 'potential-risks') {
      local = localStorage.getItem('activeFilters');
    } else if (activeTab === 'occured') {
      local = localStorage.getItem('activeFiltersIncurred');
    } else if (activeTab === 'litigation') {
      local = localStorage.getItem('activeFiltersCourt');
    }
    let res = local?.split('?');
    if (res) {
      let res1 = res[1]?.split('&');
      let arr = [];
      res1.map((item) => {
        arr.push(item.split('='));
      });
      let i;
      let j;
      setTimeout(() => {
        for (i = 0; i < arr.length; i++) {
          for (j = 0; j < arr[i].length; j++) {
            if (arr[i][j] === 'id.equals' || arr[i][j] === 'riskId.equals') {
              setValue('searchInput', arr[i][j + 1]);
              setValue('selectRisk', {
                value: 'id',
                label: `${t('risk-cosideration.id')}`,
              });
            } else if (arr[i][j] === 'title.contains') {
              setValue('searchInput', arr[i][j + 1]);
              setValue('selectRisk', {
                value: 'title',
                label: `${t('risk-cosideration.title')}`,
              });
            } else if (arr[i][j] === 'riskEstimationId.equals') {
              setValue('searchInput', arr[i][j + 1]);
              setValue('selectRisk', {
                value: 'estimation',
                label: `${t('risk-cosideration.estimation')}`,
              });
            } else if (arr[i][j] === 'applicationDate.greaterThanOrEqual') {
              let date = new Date(arr[i][j + 1]);
              setValue('dateCreated', date);
            } else if (arr[i][j] === 'applicationDate.lessThanOrEqual') {
              let date = new Date(arr[i][j + 1]);
              setValue('dateUpdated', date);
            } else if (arr[i][j] === 'departmentSourceId.in') {
              let arrDepartments = arr[i][j + 1].split(',');
              let labelDepartments = localStorage
                .getItem('departmentFilters')
                ?.split(',');
              let defaultDep = [];
              for (let k = 0; k < arrDepartments?.length; k++) {
                for (let m = 0; m < labelDepartments?.length; m++) {
                  if (
                    arrDepartments.indexOf(arrDepartments[k]) ===
                    labelDepartments.indexOf(labelDepartments[m])
                  ) {
                    defaultDep.push({
                      value: arrDepartments[k],
                      label: labelDepartments[m],
                    });
                  }
                }
              }
              setValue('department', defaultDep);
            }
          }
        }
      });
    }
  }, []);





  return (
    <>
      {loading ? (
        <Spin spinning={loading} size={'large'} className="spinner" />
      ) : (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submit)}>
            <Row className="main-container pt-5 m-0">
              <div className="w-100 wrapper d-flex justify-content-between">
                <div className="wrapper__left pr-4 d-flex">
                  <div style={{paddingBottom: '20px'}} className="wrapper__left--30 d-flex">
                    <div className="search-header w-100">
                      <InputText
                        type="text"
                        name="searchInput"
                        className="search-input"
                        placeholder={t('risk-cosideration.search.search-input')}
                      />
                      <SelectInfinite
                        name="selectRisk"
                        className="select-options"
                        options={optionsTask}

                        isClearable={true}
                        placeholder={t('placeholder.select')}
                      />
                    </div>
                  </div>
                  <div className="wrapper__left--70 d-flex">
                    <div className="w-50 d-flex">
                      <div className="w-50 d-flex">
                        <FormGroup
                          className="date-validation ml-4 mr-2"
                          name="validTo"
                          label=""
                        >
                          <InputDate
                            name="dateCreated"
                            maxDate={maxDateForCreated}
                            isClearable
                            placeholderText={t(
                              'risk-cosideration.search.dateFrom'
                            )}
                          />
                        </FormGroup>
                      </div>
                      <div className="w-50 d-flex">
                        <FormGroup
                          className="date-validation mr-4"
                          name="validForm"
                          label=""
                        >
                          <InputDate
                            name="dateUpdated"
                            minDate={minDateForUpdated}
                            isClearable
                            placeholderText={t(
                              'risk-cosideration.search.dateTo'
                            )}
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <div className="w-50 d-flex justify-content-end">
                      <FormGroup className="date-validation" name="" label="">
                        {activeTab === 'potential-risks' ? (
                          <SelectInfinite
                            api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                            name="department"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="department"
                            placeholder={t(
                              'risk-cosideration.search.organizedUnit'
                            )}
                            defaultValue={defaultDepartment}
                            isMulti={true}
                            isClearable={true}
                          />
                        ) : roleDisabled === true ? (
                          <SelectInfinite
                            api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                            name="department"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="department"
                            placeholder={t(
                              'risk-cosideration.search.organizedUnit'
                            )}
                            defaultValue={defaultDepartment}
                            isMulti={true}
                            isClearable={true}
                          />
                        ) : (
                          <SelectList
                            name="department"
                            defaultValue={defaultDepartment}
                            placeholder={t(
                              'risk-cosideration.search.organizedUnit'
                            )}
                            options={departmentOptions}
                            isClearable={false}
                            isMulti
                          />
                        )}
                      </FormGroup>
                    </div>
                  </div>
                </div>
                <div className="wrapper__right">
                  <button
                    className="float-right search-button primary-btn"
                    disabled={false}
                    type="submit"
                  >
                    {t('risk-cosideration.search.searchButton')}
                  </button>
                </div>
              </div>
            </Row>
          </form>
        </FormProvider>
      )}
    </>
  );
};
export default RiskFilter;
